import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/my-account/login'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/my-account/dist/index.css'

const LoginPage: NextPage = () => {
  const richText = `
  <h4>No account yet?</h4>
  <p style="margin-bottom: 1rem;">Create an account to manage your eyecare with Vision Express.</p>
  <ul class="checkmark-list">
    <li>Manage your contact lens subscription.</li>
    <li>Manage your appointment bookings.</li>
    <li>Top-up and re-order contact lenses.</li>
    <li>View your online order history.</li>
  </ul>
  `

  return <Page richText={richText} />
}

export default compose(withCms(), withLayout(), withCart({ readOnly: true }))(LoginPage)
